export interface Difference {
  type: 'addition' | 'deletion' | 'modification';
  section?: string;
  customerContent?: string;
  templateContent?: string;
}

export interface DocumentComparison {
  differences: Difference[];
  customerText?: string;
  templateText?: string;
}

export const ndaComplianceService = {
  convertToDocumentComparison(input: any): DocumentComparison {
    const differences: Difference[] = Array.isArray(input?.differences)
      ? input.differences.map((d: any) => ({
          type: d?.type as Difference['type'],
          section: d?.section ?? undefined,
          customerContent:
            d?.customerContent == null
              ? undefined
              : (d.customerContent as string),
          templateContent:
            d?.templateContent == null
              ? undefined
              : (d.templateContent as string)
        }))
      : [];

    const customerText: string | undefined =
      typeof input?.customerText === 'string' ? input.customerText : undefined;
    const templateText: string | undefined =
      typeof input?.templateText === 'string' ? input.templateText : undefined;

    return { differences, customerText, templateText };
  }
};
